module.exports = __webpack_public_path__ + "img/facebook.fb704567.svg";